<template>
    <div>
        <add-o-p-component/>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    }
}
</script>

<style>
</style>